import { defineComponent as _defineComponent } from 'vue'
import OzBaseSnackbar from 'library/v4/components/OzBaseSnackbar.vue'
import { storeToRefs } from 'pinia'
import { useGlobalSnackbarStore } from 'pinia/global_snackbar'


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalSnackbar',
  props: {
    darkMode: { type: [Boolean, String] }
  },
  setup(__props: any) {



const globalSnackbarStore = useGlobalSnackbarStore()
const { snackbarArray } = storeToRefs(globalSnackbarStore)
const { executeActions } = globalSnackbarStore

function calculateSnackbarPosition(snackbarIndex: number): string {
  // 49 is the height of snackbar plus margin between snackbars
  // each subsequent snackbar is height plus margin of a snackbar from the top of the viewport plus initial gap (16px)
  return `${snackbarIndex * 49 + 16}px`
}

return { __sfc: true,globalSnackbarStore, snackbarArray, executeActions, calculateSnackbarPosition, OzBaseSnackbar }
}

})